import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { HTML_LINK_TARGET } from '../../../constants/html'
import Modal, { Box, Content, Header } from '../../Modal'
import { NotificationInline } from '../../Notification'
import { Table } from '../../Table'
import { reconnectEmailAccount } from '../Email.api'

import {
  EMAIL_RECONNECT_ACCOUNT_TABLE_COLUMNS,
  QA_NAME_RECONNECT_ACCOUNTS_MODAL,
} from './EmailReconnectAccountsModal.constants'
import { EmailReconnectTableRow } from './EmailReconnectTableRow'

import * as styles from './EmailReconnectAccountsModal.module.css'

function EmailReconnectAccountsModal(props) {
  const { accounts } = props

  const { t } = useTranslation()

  const containerRef = useRef(null)

  function handleClickReconnect(id) {
    reconnectEmailAccount(id).then(response => {
      window.open(response?.data?.auth_url, HTML_LINK_TARGET.blank)
    })
  }

  return (
    <Modal qaName={QA_NAME_RECONNECT_ACCOUNTS_MODAL} onClose={props.onClose}>
      <Box>
        <Header
          text={t('Modal.EmailReconnectAccountsTitleKey')}
          onClose={props.onClose}
        />
        <Content className={styles.content} contentRef={containerRef} size='xl'>
          <NotificationInline
            className={styles.notification}
            text={t('Emails.EmailReconnectMessageInfoNotificationModalKey')}
            type={NOTIFICATION_TYPE.info}
          />
          <Table
            TableRow={EmailReconnectTableRow}
            actionsColumnWidth={null}
            className={styles.table}
            columns={EMAIL_RECONNECT_ACCOUNT_TABLE_COLUMNS}
            containerRef={containerRef}
            headerRowProps={{
              resizable: false,
            }}
            items={accounts}
            rowProps={{
              onClickButton: handleClickReconnect,
            }}
          />
        </Content>
      </Box>
    </Modal>
  )
}

export default EmailReconnectAccountsModal
